module.exports = __webpack_public_path__ + "img/text.95ea8138.png";